import React, {useState} from 'react';
import './style.css';
import {Select} from 'antd';
import {SelectMode} from "./select-mode/SelectMode";
import {ReactComponent as SelectArrayIcon} from '../../../../assets/i/select-array-icon.svg';
import {ReactComponent as ArrowUpIconIcon} from '../../../../assets/i/arrow-up-icon.svg';
import {useAppSelector} from "../../../../common/hook";

interface CourseFilterProps {
    onPaymentChange: (value: string) => void;
}

export const CourseFilter = ({ onPaymentChange }: CourseFilterProps) => {
    const currencies = useAppSelector((state) => state.courses.courseData.currencies);

    const [open, setOpen] = useState(false);
    const [selectedPayment, setSelectedPayment] = useState('BYN');



    const onClickHandler = () => {
        setOpen(!open);
    };



    const handleChange = (name: string, value: string) => {
        if (name === 'payment') {
            setSelectedPayment(value);
            onPaymentChange(value);
        }
    };



    const currencyOptions = currencies
        ? currencies.map((currency) => ({
            label: currency.abbreviation,
            value: currency.abbreviation,
        }))
        : [];


    return (
        <div className="course-filter">
            <div className="course-type-new">
                <SelectMode />
            </div>

            <div id="course" className="course-payment course-type" onClick={onClickHandler}>
                <span className="currency-selection">Оплата в</span>
                <Select
                    defaultValue={selectedPayment}
                    suffixIcon={open ? <ArrowUpIconIcon /> : <SelectArrayIcon />}
                    style={{ width: "185px" }}
                    onChange={(value) => handleChange("payment", value)}
                    options={currencyOptions}
                />
            </div>
        </div>
    );
};
